import { AbstractControl } from '@angular/forms';



export function phoneNumberValidator(control : AbstractControl){
    if(control && control.value !== null || control.value !== undefined){
        const regex= new RegExp('^[6-9]{1}[0-9]{9}$');
        if(!regex.test(control.value)){
            return {isError : true};
        }
    }

    return null;
}

export function agencyValidator(control : AbstractControl){

    if(control){
        const agency =control.value
        const posType=control.root.get('posType');
        if(posType){
            if(posType.value==='Temporary'|| posType.value==='Contractual'){
                if(agency===''){
                    return {isError : true}
                }
        
            }
            

        }
        
        return null;

    }
    

}